module.exports = __webpack_public_path__ + "static/img/11.dc4650d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/sp/11.png
// module id = kE4a
// module chunks = 0